import { Button, ETextStyleVariant, GeneralEyeNormalIcon, Text } from '@outdoorsyco/bonfire';
import { useIntl } from 'react-intl';

type TQuickPreviewButtonProps = {
  onClick: () => void;
};

export const QuickPreviewButtonDesktop = ({ onClick }: TQuickPreviewButtonProps) => {
  const intl = useIntl();

  if (!onClick) return null;

  return (
    <Button
      className="p-0 border-none rounded-full"
      onClick={onClick}
      onClickCapture={(e: React.MouseEvent) => {
        e.preventDefault();
      }}
      aria-label={intl.formatMessage({
        defaultMessage: 'Open quick preview for rental',
        id: 'GIFCZE',
      })}
      label={
        <div className="px-4 py-2 bg-white rounded-full">
          <Text variant={ETextStyleVariant.SmallBold}>
            {intl.formatMessage({ defaultMessage: 'Quick Preview', id: 'ifQN+L' })}
          </Text>
        </div>
      }
    />
  );
};

export const QuickPreviewButtonMobile = ({ onClick }: TQuickPreviewButtonProps) => {
  const intl = useIntl();

  if (!onClick) return null;

  return (
    <Button
      className="p-0 border-none rounded-full"
      onClick={onClick}
      onClickCapture={(e: React.MouseEvent) => {
        e.preventDefault();
      }}
      aria-label={intl.formatMessage({
        defaultMessage: 'Open quick preview for rental',
        id: 'GIFCZE',
      })}
      label={
        <div className="w-full h-full px-2 py-2 bg-white rounded-full">
          <GeneralEyeNormalIcon />
        </div>
      }
    />
  );
};
